// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";

import {Carousel, CarouselItem} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(Carousel);
Vue.use(CarouselItem);

/* 路由 */
import router from "./router";

/* vuex */
import store from "./store";

/* axios */
import axios from "./api";
// import api from './api/api'
import "amfe-flexible";

Vue.prototype.http = axios;
// Vue.prototype.api = api;

/* swiper */
// import Swiper from "swiper";
// import "swiper/css/swiper.min.css";

/* 重置样式 */
import "./assets/css/reset.min.css";

import VueLazyload from "vue-lazyload";
Vue.use(VueLazyload);
console.log(VueLazyload, "VueLazyload");

/* jquery */
import "jquery";

/* bootstarp */
import "./assets/css/bootstrap.min.css";
import "./assets/js/bootstrap.min";
import "./assets/css/fonts.css";

/* animate.css */
import "animate.css";

/* 头部组件 */
// import Header from "./components/NewHeader";
// Vue.component(Header.name, Header);

/* 头部组件2 */
import Header from "./components/NewHeader2";
Vue.component(Header.name, Header);

/* 尾部组件 */
// import Footer from "./components/Footer";
// Vue.component(Footer.name, Footer);

/* 尾部组件2 */
import Footer from "./components/Footer2";
Vue.component(Footer.name, Footer);

/* 尾部组件2 */
import ExhibitionFooter from "./components/ExhibitionFooter";
Vue.component(ExhibitionFooter.name, ExhibitionFooter);

/* 回到顶部 */
import GoTop from "./components/GoTop";
import { name } from "file-loader";
// import { monitorZoom } from "@/utils/monitorZoom.js";
// const m = monitorZoom();
// if (window.screen.width * window.devicePixelRatio >= 3840) {
//   document.body.style.zoom = 100 / (Number(m) / 2); // 屏幕为 4k 时
// } else {
//   document.body.style.zoom = 100 / Number(m);
// }

Vue.component(GoTop.name, GoTop);

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (to.meta.keywords) {
    document
      .querySelector("meta[name='keywords']")
      .setAttribute("content", to.meta.keywords);
  } else {
    const keywords =
      "赛博威，赛博威科技，Cyberway，数字营销赋能专家，营销一体化解决方案，营销端数字化解决方案，数智营销费用管理，3A模型，企业数字化转型伙伴";
    document
      .querySelector("meta[name='keywords']")
      .setAttribute("content", keywords);
  }
  next();
});

new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js